const yieldProgressBarSteps = [
  {
    caption: 'Select Properties'
  },
  {
    caption: 'Enter Yield Info'
  }
];
export default yieldProgressBarSteps;
